module.exports = __webpack_public_path__ + "static/actionlist-actionbar-dont-daa848fefed50170affba680f1fadcb3.png";